import { render, staticRenderFns } from "./formgrouptext.vue?vue&type=template&id=57ec3c20&"
import script from "./formgrouptext.vue?vue&type=script&lang=js&"
export * from "./formgrouptext.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports